import axios from "axios";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

const API_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Login function
 */
export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/Auth/Login`, {
      username,
      password,
    });

    const token = response.data?.token || response.data;

    // If no token returned, treat as invalid login
    if (!token || typeof token !== "string") {
      throw new Error("Invalid username or password");
    }

    // Decode token safely
    let decoded;
    try {
      decoded = jwtDecode(token);
    } catch {
      throw new Error("Invalid username or password");
    }

    // Allow only Admin role
    if (!decoded.role || decoded.role !== "Admin") {
      throw new Error("Only Admin users can login");
    }

    // Save token and user info
    Cookies.set("auth_token", token, { expires: 1 });
    Cookies.set(
      "user",
      JSON.stringify({
        username: decoded.unique_name || decoded.username,
        role: decoded.role,
      }),
      { expires: 1 },
    );

    return decoded;
  } catch (error) {
    console.error("Login failed:", error);
    throw new Error(error.message || "Invalid username or password");
  }
};

/**
 * Get token from cookies
 */
export const getToken = () => Cookies.get("auth_token");

/**
 * Get logged-in user
 */
export const getUser = () => {
  const user = Cookies.get("user");
  return user ? JSON.parse(user) : null;
};

/**
 * Logout
 */
export const logout = () => {
  Cookies.remove("auth_token");
  Cookies.remove("user");
};
